let openErrorModalCallback = null;

export const registerErrorModalOpener = (callback) => {
  openErrorModalCallback = callback;
};

export const openErrorDetailsModal = (errors) => {
  if (!openErrorModalCallback) {
    console.error("Error modal opener is not registered!");
    return;
  }

  openErrorModalCallback(errors);
};
